import {connect} from 'react-redux';
import {Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import OrderPage from "./OrderPage";
import DopravaForm from "../../../forms/DopravaForm";
import * as localStorageUtils from "../../../utils/localStorageUtils";
import {withRouter} from "react-router";
import {formatTime, getMaximalniCas, getMinimalniCas, redirectToOrderStepNumber} from "../../../utils/utils";
import * as opravneniActions from "../../../actions/opravneniActions";
import * as ciselnikActions from "../../../actions/ciselnikActions";
import * as subjektActions from "../../../actions/subjektActions";
import * as uzivatelActions from "../../../actions/uzivatelActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import * as EnumFormaDoruceni from "../../../api/gen/cgo/EnumFormaDoruceni";
import {SubmissionError} from "redux-form";
import {TIME_STEP} from "../../../const/const";
import moment from "moment";
import {withTranslation, WithTranslation} from "react-i18next";

const {storeFromArea} = utils;

const CURRENT_STEP = 3;

/**
 * Stránka procesu objednávky - Doprava.
 */
class DopravaPage extends Component<WithTranslation> {

    unsavedData = null;

    storedData = null;

    componentDidMount() {
        this.fetchData();
        this.storedData = null;
        this.loadStoredOrderData(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.loggedInUser.fetched && nextProps.loggedInUser.fetched) {
            this.loadStoredOrderData(nextProps);
        }
    }

    loadStoredOrderData = (props) => {
        const {loggedInUser} = props;
        if (loggedInUser.data) {
            this.storedData = localStorageUtils.loadOrderData(loggedInUser.data.id, CURRENT_STEP);
        }
    };

    componentDidUpdate() {
        this.fetchData();
    }

    componentWillUnmount() {
        const {loggedInUser} = this.props;
        if (this.unsavedData) {
            this.saveData(this.unsavedData);
            this.props.dispatch(objednavkaActions.invalidateDataDoprava());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        }
    };

    fetchData = () => {
        const {loggedInUser, aktivniSpolecnostId, zakaznikData} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            const loggedInUserId = loggedInUser.data.id;
            this.props.dispatch(objednavkaActions.fetchDataZakazkaIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchDataZakaznikIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchDataDopravaIfNeeded(loggedInUserId));
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUserId));
            this.props.dispatch(subjektActions.fetchAktivniAdresyUzivatelIfNeeded(loggedInUserId, aktivniSpolecnostId.data));
            if (aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching) {
                // aktivniSpolecnostId tady může být null, ale to nevadí
                this.props.dispatch(ciselnikActions.fetchPobockyUzivatelIfNeeded(aktivniSpolecnostId.data, loggedInUserId));
                this.props.dispatch(subjektActions.fetchUzivatelVychoziHodnotyIfNeeded(loggedInUserId, aktivniSpolecnostId.data));
                if (aktivniSpolecnostId.data) {
                    this.props.dispatch(subjektActions.fetchAktivniSpolecnostDetailIfNeeded(aktivniSpolecnostId.data));
                    this.props.dispatch(subjektActions.fetchAktivniAdresySpolecnostIfNeeded(aktivniSpolecnostId.data));
                }
            }
            // Pokud z kroku Zákazník máme uživatele (tj. jsem operátor), musíme načíst data pro tohoto uživatele
            if (zakaznikData.fetched && zakaznikData.data && zakaznikData.data.uzivatelASpolecnost) {
                const uzivatelId = zakaznikData.data.uzivatelASpolecnost.uzivatelId;
                const spolecnostId = zakaznikData.data.uzivatelASpolecnost.spolecnostId;
                this.props.dispatch(objednavkaActions.fetchObjednavkaUzivatelAdresyIfNeeded(uzivatelId));
                // spolecnostId tady může být null, ale to nevadí
                this.props.dispatch(objednavkaActions.fetchObjednavkaUzivatelPobockyIfNeeded(uzivatelId, spolecnostId));
                this.props.dispatch(objednavkaActions.fetchObjednavkaUzivatelVychoziHodnotyIfNeeded(uzivatelId, spolecnostId));
                if (spolecnostId) {
                    this.props.dispatch(objednavkaActions.fetchObjednavkaSpolecnostIfNeeded(spolecnostId));
                    this.props.dispatch(objednavkaActions.fetchObjednavkaSpolecnostAdresyIfNeeded(spolecnostId));
                }
            }
        }
    };

    isFetched = () => {
        const {firmaDetail, pobockyUzivatelList, aktivniAdresyUzivatelList, aktivniAdresySpolecnostList,
            aktivniSpolecnostDetail, objednavkaSpolecnostDetail, zpusobyDopravyList, aktivniSpolecnostId, zakazkaData,
            zakaznikData, dopravaData, objednavkaUzivatelAdresyList, objednavkaSpolecnostAdresyList, objednavkaUzivatelPobockyList,
            uzivatelVychoziHodnotyDetail, objednavkaUzivatelVychoziHodnotyDetail} = this.props;

        const uzivatelUrcenOperatorem = zakaznikData.fetched && !zakaznikData.isFetching && zakaznikData.data && zakaznikData.data.uzivatelASpolecnost;
        const uzivatelSpolecnostId = uzivatelUrcenOperatorem && zakaznikData.data.uzivatelASpolecnost.spolecnostId;

        return firmaDetail.fetched && !firmaDetail.isFetching
            && uzivatelVychoziHodnotyDetail.fetched && !uzivatelVychoziHodnotyDetail.isFetching
            && pobockyUzivatelList.fetched && !pobockyUzivatelList.isFetching
            && aktivniAdresyUzivatelList.fetched && !aktivniAdresyUzivatelList.isFetching
            && zpusobyDopravyList.fetched && !zpusobyDopravyList.isFetching
            && aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching
            && zakazkaData.fetched && !zakazkaData.isFetching
            && zakaznikData.fetched && !zakaznikData.isFetching
            // pokud máme načtené ID svojí aktivní společnosti, musíme načíst její adresy a detail
            && (aktivniSpolecnostId.data ? aktivniAdresySpolecnostList.fetched && !aktivniAdresySpolecnostList.isFetching &&
                aktivniSpolecnostDetail.fetched && !aktivniSpolecnostDetail.isFetching : true)
            // pokud máme uživatele daného operátorem, musíme načíst jeho detail, adresy, výdejní pobočky a výchozí hodnoty
            && (uzivatelUrcenOperatorem ?
                objednavkaUzivatelAdresyList.fetched && !objednavkaUzivatelAdresyList.isFetching &&
                objednavkaUzivatelPobockyList.fetched && !objednavkaUzivatelPobockyList.isFetching &&
                objednavkaUzivatelVychoziHodnotyDetail.fetched && !objednavkaUzivatelVychoziHodnotyDetail.isFetching : true)
            // pokud máme uživatele daného operátorem a ten má společnost, musíme načíst její adresy a detail
            && (uzivatelSpolecnostId ? objednavkaSpolecnostAdresyList.fetched && !objednavkaSpolecnostAdresyList.isFetching && objednavkaSpolecnostDetail.fetched && !objednavkaSpolecnostDetail.isFetching : true)
            && dopravaData.fetched && !dopravaData.isFetching
    };

    saveData = (data) => {
        const {loggedInUser} = this.props;
        let savedData = data;
        if (data.naPobocku) {
            // Při vyzvednutí na pobočce nechceme posílat v objednávce adresu
            const {adresa, adresaId, ulice, obec, psc, stat, ...other} = data;
            savedData = other;
        }
        localStorageUtils.saveOrderData(loggedInUser.data.id, CURRENT_STEP, savedData);
        this.unsavedData = null;
    };

    invalidateAndContinue = () => {
        const {loggedInUser} = this.props;
        this.props.dispatch(objednavkaActions.invalidateDataDoprava());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastFinishedStep(loggedInUser.data.id));
        redirectToOrderStepNumber(CURRENT_STEP + 1, this.props);
    };

    isPobockaNeaktivni = (pobockaId) => {
        const {pobockyUzivatelList, objednavkaUzivatelPobockyList, zakaznikData} = this.props;
        const uzivatelUrcenOperatorem = !!zakaznikData.data.uzivatelASpolecnost;
        const pobocky = uzivatelUrcenOperatorem ? objednavkaUzivatelPobockyList.rows : pobockyUzivatelList.rows;
        // pozor, jen dvě rovnítka jsou zde záměrně - může to někdy být string
        return pobocky && pobocky.some(p => p.id == pobockaId && p.neaktivni);
    }

    render() {
        const {aktivniSpolecnostDetail, objednavkaSpolecnostDetail, dopravaData,
            firmaDetail, pobockyUzivatelList, objednavkaUzivatelAdresyList, objednavkaSpolecnostAdresyList, objednavkaUzivatelPobockyList,
            aktivniAdresyUzivatelList, aktivniAdresySpolecnostList, zpusobyDopravyList, zakazkaData, zakaznikData,
            uzivatelVychoziHodnotyDetail, objednavkaUzivatelVychoziHodnotyDetail, t} = this.props;

        if (!this.isFetched()) {
            return <Loader/>;
        }

        const uzivatelUrcenOperatorem = !!zakaznikData.data.uzivatelASpolecnost;
        const maSpolecnost = uzivatelUrcenOperatorem ? !!zakaznikData.data.uzivatelASpolecnost.spolecnostId : !!aktivniSpolecnostDetail.data;

        const firma = firmaDetail.data;
        const spolecnost = uzivatelUrcenOperatorem ? maSpolecnost ? objednavkaSpolecnostDetail.data : null : aktivniSpolecnostDetail.data;
        const adresyUzivatel = uzivatelUrcenOperatorem ? objednavkaUzivatelAdresyList.rows : aktivniAdresyUzivatelList.rows;
        const adresySpolecnost = maSpolecnost ? uzivatelUrcenOperatorem ? objednavkaSpolecnostAdresyList.rows : aktivniAdresySpolecnostList.rows : null;
        const pobocky = uzivatelUrcenOperatorem ? objednavkaUzivatelPobockyList.rows : pobockyUzivatelList.rows;

        const vychoziHodnoty = uzivatelUrcenOperatorem ? objednavkaUzivatelVychoziHodnotyDetail.data : uzivatelVychoziHodnotyDetail.data;
        const vychoziZpusobDoprava = vychoziHodnoty.zpusobDoprava;
        const vychoziTerminDoprava = vychoziHodnoty.terminDoprava;
        const vychoziAdresa = vychoziHodnoty.dorucovaciAdresa;
        const vychoziPobocka = vychoziHodnoty.pobocka;
        const vychoziDatumDoruceni = moment().add(1, 'days').toDate();
        const vychoziDatumVyzvednuti = new Date();

        const pobockaId = vychoziPobocka && vychoziPobocka.id;
        const zpusobDopravaId = vychoziZpusobDoprava && vychoziZpusobDoprava.id;
        const terminDopravaId = vychoziTerminDoprava && vychoziTerminDoprava.id;
        const preskocitDopravuPovoleno = spolecnost && spolecnost.preskocitDoprava;
        const naPobocku = vychoziZpusobDoprava ? vychoziZpusobDoprava.formaDoruceni === EnumFormaDoruceni.POB : null;
        const casVyzvednuti = formatTime(getMinimalniCas(firmaDetail.data, vychoziPobocka,  new Date()), null, "HH:mm:ss");

        const initialValues = {
            pobockaId: pobockaId,
            zpusobDopravaId: zpusobDopravaId ? zpusobDopravaId.toString() : null,
            terminDopravaId: terminDopravaId ? terminDopravaId.toString() : null,
            naPobocku: naPobocku,
            datumDoruceni: vychoziDatumDoruceni,
            datumVyzvednuti: vychoziDatumVyzvednuti,
            casVyzvednuti: casVyzvednuti,
            adresa: vychoziAdresa ? vychoziAdresa : null,
            ulice: vychoziAdresa ? vychoziAdresa.ulice : null,
            psc: vychoziAdresa ? vychoziAdresa.psc : null,
            obec: vychoziAdresa ? vychoziAdresa.obec : null,
            stat: vychoziAdresa ? vychoziAdresa.stat : null,
            ...dopravaData.data
        };

        this.overrideWithLoadedData(initialValues);

        // Pokud jsou vyplněna potřebná data a ještě žádná nemáme uložená, můžeme krok přeskočit
        if (preskocitDopravuPovoleno && !dopravaData.data) {
            const adresaVyplnena = vychoziAdresa && vychoziAdresa.ulice && vychoziAdresa.psc && vychoziAdresa.obec;
            const lzeNaAdresu = adresaVyplnena && vychoziZpusobDoprava && vychoziZpusobDoprava.formaDoruceni === EnumFormaDoruceni.ADR && vychoziAdresa && vychoziTerminDoprava;
            const lzeNaPobocku = pobockaId && !this.isPobockaNeaktivni(pobockaId) && vychoziZpusobDoprava && vychoziZpusobDoprava.formaDoruceni === EnumFormaDoruceni.POB && casVyzvednuti;
            if (lzeNaAdresu || lzeNaPobocku) {
                // console.debug("Přeskakuji krok doprava");
                this.saveData({...initialValues, finished: true});
                this.invalidateAndContinue();
            }
        }

        return <OrderPage title={t('pages.main.title')} subtitle={t('order.new')} currentStep={CURRENT_STEP}>
            <DopravaForm
                onSubmit={data => {
                    return new Promise((resolve, reject) => {
                        if (!data.zpusobDopravaId) {
                            const errors = {
                                _error: t('validation.delivery_form_required')
                            };
                            reject(new SubmissionError(errors));
                        }
                        if (data.naPobocku && this.isPobockaNeaktivni(data.pobockaId)) {
                            const errors = {
                                _error: t('validation.branch_inactive')
                            };
                            reject(new SubmissionError(errors));
                        }
                        resolve(this.saveData({...data, finished: true}));
                    });
                }}
                onSubmitSuccess={this.invalidateAndContinue}
                onChange={(data) => this.unsavedData = data}
                initialValues={initialValues}
                pobockyList={pobocky}
                zpusobyDopravyList={zpusobyDopravyList.rows}
                adresyList={adresySpolecnost && adresySpolecnost.length > 0 ? [...adresyUzivatel, ...adresySpolecnost] : adresyUzivatel}
                zobrazovatCasOd={getMinimalniCas(firma, vychoziPobocka, initialValues.datumVyzvednuti)}
                zobrazovatCasDo={getMaximalniCas(firma)}
                krokCasMinut={firma.krokCasMinut ? firma.krokCasMinut : TIME_STEP}
                zakazkaData={zakazkaData.data}
                zakaznikData={zakaznikData.data}
            />
        </OrderPage>
    }

    overrideWithLoadedData(initialValues) {
        if (this.storedData) {
            initialValues.pobockaId = this.storedData.pobockaId;
            initialValues.zpusobDopravaId = this.storedData.zpusobDopravaId;
            initialValues.terminDopravaId = this.storedData.terminDopravaId;
            initialValues.naPobocku = this.storedData.naPobocku;
            initialValues.datumDoruceni = this.storedData.datumDoruceni;
            initialValues.datumVyzvednuti = this.storedData.datumVyzvednuti;
            initialValues.casVyzvednuti = this.storedData.casVyzvednuti;
        }
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        objednavkaUzivatelAdresyList: storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_ADRESY_AREA),
        objednavkaUzivatelPobockyList: storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_POBOCKY_AREA),
        objednavkaUzivatelVychoziHodnotyDetail: storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA),
        objednavkaSpolecnostAdresyList: storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_ADRESY_AREA),
        firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
        pobockyUzivatelList: utils.storeFromArea(state, ciselnikActions.POBOCKY_UZIVATEL_LIST_AREA),
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        aktivniAdresyUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_ADRESY_LIST_AREA),
        aktivniAdresySpolecnostList: utils.storeFromArea(state, subjektActions.SPOLECNOST_AKTIVNI_ADRESY_LIST_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        aktivniSpolecnostDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA),
        uzivatelVychoziHodnotyDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_VYCHOZI_HODNOTY_AREA),
        objednavkaSpolecnostDetail: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_AREA),
        zakazkaData: utils.storeFromArea(state, objednavkaActions.ZAKAZKA_DETAIL_AREA),
        zakaznikData: utils.storeFromArea(state, objednavkaActions.ZAKAZNIK_DETAIL_AREA),
        dopravaData: utils.storeFromArea(state, objednavkaActions.DOPRAVA_DETAIL_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(DopravaPage)));

